import { render, staticRenderFns } from "./GameMain.vue?vue&type=template&id=8e8a8518&scoped=true"
import script from "./GameMain.vue?vue&type=script&lang=js"
export * from "./GameMain.vue?vue&type=script&lang=js"
import style0 from "./GameMain.vue?vue&type=style&index=0&id=8e8a8518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8a8518",
  null
  
)

export default component.exports